import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="relative bg-gray-900 text-white">
      {/* Background Image */}
      <div 
        className="h-24 md:h-40 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=1920)',
        }}
      ></div>
      
      {/* Links Bar */}
      <div className="bg-gray-300 py-4 md:py-6">
        <div className="max-w-[1300px] mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Left Side - Navigation Links */}
            <div className="flex flex-wrap justify-center md:justify-start items-center gap-4 md:gap-6">
              <Link to="/" className="text-xs md:text-sm font-bold text-gray-900 hover:text-gray-700 transition-colors uppercase tracking-wide underline">
                Home
              </Link>
              <Link to="/rider-training" className="text-xs md:text-sm font-bold text-gray-900 hover:text-gray-700 transition-colors uppercase tracking-wide underline">
                Rider Training
              </Link>
              <Link to="/summer-camps" className="text-xs md:text-sm font-bold text-gray-900 hover:text-gray-700 transition-colors uppercase tracking-wide underline">
                Summer Camps
              </Link>
              <Link to="/bike-rentals" className="text-xs md:text-sm font-bold text-gray-900 hover:text-gray-700 transition-colors uppercase tracking-wide underline">
                Rentals
              </Link>
              <Link to="/special-events" className="text-xs md:text-sm font-bold text-gray-900 hover:text-gray-700 transition-colors uppercase tracking-wide underline">
                Event Bookings
              </Link>
              <Link to="/store" className="text-xs md:text-sm font-bold text-gray-900 hover:text-gray-700 transition-colors uppercase tracking-wide underline">
                Store
              </Link>
            </div>

            {/* Right Side - Social Media Icons */}
            <div className="flex items-center gap-4">
              {/* Facebook */}
              <a 
                href="https://www.facebook.com/ThrottleEdgeMX/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-blue-600 transition-colors"
                aria-label="Facebook"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>

              {/* Instagram */}
              <a 
                href="https://www.instagram.com/ThrottleEdgeMX/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-pink-600 transition-colors"
                aria-label="Instagram"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>

              {/* Twitter/X */}
              <a 
                href="https://twitter.com/ThrottleEdgeMX" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-blue-400 transition-colors"
                aria-label="Twitter"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
                </svg>
              </a>

              {/* TikTok */}
              <a 
                href="https://www.tiktok.com/@ThrottleEdgeMX" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-black transition-colors"
                aria-label="TikTok"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-1-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>

              {/* YouTube */}
              <a 
                href="https://www.youtube.com/channel/UCVbLmSeAd-U_98uFN3bHPyw" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-red-600 transition-colors"
                aria-label="YouTube"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                </svg>
              </a>

              {/* Threads */}
              <a 
                href="https://www.threads.net/@ThrottleEdgeMX" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-900 hover:text-gray-700 transition-colors"
                aria-label="Threads"
              >
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.186 24h-.007c-3.581-.024-6.334-1.205-8.184-3.509C2.35 18.44 1.5 15.586 1.472 12.01v-.017c.03-3.579.879-6.43 2.525-8.482C5.845 1.205 8.6.024 12.18 0h.014c2.746.02 5.043.725 6.826 2.098 1.677 1.29 2.858 3.13 3.509 5.467l-2.04.569c-1.104-3.96-3.898-5.984-8.304-6.015-2.91.022-5.11.936-6.54 2.717C4.307 6.504 3.616 8.914 3.589 12c.027 3.086.718 5.496 2.057 7.164 1.43 1.783 3.631 2.698 6.54 2.717 2.623-.02 4.358-.631 5.8-2.045 1.647-1.613 1.618-3.593 1.09-4.798-.31-.71-.873-1.3-1.634-1.75-.192 1.352-.622 2.446-1.284 3.272-.886 1.102-2.14 1.704-3.73 1.79-1.202.065-2.361-.218-3.259-.801-1.063-.689-1.685-1.74-1.752-2.964-.065-1.19.408-2.285 1.33-3.082.88-.76 2.119-1.207 3.583-1.291a13.853 13.853 0 0 1 3.02.142l-.126 1.974a11.881 11.881 0 0 0-2.588-.12c-1.014.058-1.84.355-2.456.882-.578.495-.897 1.187-.897 1.941 0 .467.165.914.465 1.26.3.345.717.57 1.174.633 1.097.15 2.483-.123 3.096-1.676.177-.448.3-.98.364-1.612l.257-3.44c.02-.27.02-.54 0-.81-.02-.27-.06-.54-.12-.81-.12-.54-.3-1.02-.54-1.44-.24-.42-.54-.78-.9-1.08-.36-.3-.78-.54-1.26-.72-.48-.18-1.02-.27-1.62-.27-.6 0-1.14.09-1.62.27-.48.18-.9.42-1.26.72-.36.3-.66.66-.9 1.08-.24.42-.42.9-.54 1.44-.06.27-.1.54-.12.81-.02.27-.02.54 0 .81l.257 3.44c.064.632.187 1.164.364 1.612.613 1.553 1.999 1.826 3.096 1.676.457-.063.874-.288 1.174-.633.3-.346.465-.793.465-1.26 0-.754-.319-1.446-.897-1.941-.616-.527-1.442-.824-2.456-.882a11.881 11.881 0 0 0-2.588.12l-.126-1.974a13.853 13.853 0 0 1 3.02-.142c1.464.084 2.703.531 3.583 1.291.922.797 1.395 1.892 1.33 3.082-.067 1.224-.689 2.275-1.752 2.964-.898.583-2.057.866-3.259.801-1.59-.086-2.844-.688-3.73-1.79-.662-.826-1.092-1.92-1.284-3.272-.761.45-1.324 1.04-1.634 1.75-.528 1.205-.557 3.185 1.09 4.798 1.442 1.414 3.177 2.025 5.8 2.045 2.91-.019 5.11-.934 6.54-2.717 1.339-1.668 2.03-4.078 2.057-7.164-.027-3.086-.718-5.496-2.057-7.164-1.43-1.781-3.63-2.695-6.54-2.717z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright Bar */}
      <div className="bg-gray-800 py-3">
        <div className="max-w-[1300px] mx-auto px-4">
          <p className="text-center text-xs md:text-sm text-gray-300">
            © 2026 Throttle Edge All Rights Reserved. | Developed By: <a href="https://awktechz.com/" target="_blank" rel="noopener noreferrer" className="text-white hover:text-gray-400 transition-colors underline">AWKT</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
